module.exports = __webpack_public_path__ + "assets/img/Whatsapp.ddfc7b35.svg";